//MAIN HEADER
(function( $ ){

    //MENU TOGGLE
    "use strict";

    $('.main_menu > li:has( > ul)').addClass('has-menu');

    $('.main_menu > li > ul:not(:has(ul))').addClass('normal-sub');

    $('.main_menu > li:has( > ul) > a').click(function(e) {
        $(this).next('.depth_0').toggle();
        $('.main_menu > li > a').not($(this)).next('.depth_0').hide();
        e.preventDefault();
        e.stopPropagation();
    });

    $('.depth_0').click(function(e) {
        e.stopPropagation();
    });
    //If width is more than 943px dropdowns are displayed on hover

    $(".main_menu > li").click(function() {
        if ($(window).width() <= 943) {
            $(this).children("ul").fadeToggle(150);
        }
    });
    $('.mob_menu > li:has( > ul) > a').addClass('not_active');
    $(".mob_menu > li").click(function(e) {
        $(this).children("ul").fadeToggle(150);
    });
    //If width is less or equal to 943px dropdowns are displayed on click (thanks Aman Jain from stackoverflow)

    $(".menu-mobile").click(function(e) {
        $(".main_menu").toggleClass('show-on-mobile');
        e.preventDefault();
    });
    //when clicked on mobile-menu, normal menu is shown as a list, classic rwd menu story (thanks mwl from stackoverflow)

    //MOB MENU TOGGLE
    $('.hamburger-box').click(function(){
        $('.hamburger--3dx').toggleClass("is-active");
        $(this).toggleClass('open');
        $(".mob").slideToggle('fast');
    });


     //SLIDER POST
     var mySwiper = new Swiper('.swiper-container', {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    
    /*FRONT PAGE HOVER */
    if($(".profile_text").length > 0){

        $("#img-newsletter").hover(
            function() {
                $(this).attr("src", "/wp-content/uploads/2024/04/newsletter-orange.png"); 
            },
            function() {
                $(this).attr("src", "/wp-content/uploads/2024/04/newsletter-svg.png"); 
            }
        );

    }

})(jQuery);
